






import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 5.0.0 Declare its context to children.
 */
@Component
export default class JdsTableRow extends Vue {
    @ActiveProvide('jds.table-row.context') provideContext = true

    get hasDetails() {
        return this.$slots['details']
    }
}
